import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isNil } from 'lodash';
import { trackError } from 'utils/helpers';
import {
  fetchBookabilityFailure,
  fetchBookabilityStarted,
  fetchBookabilitySucceeded,
  setBookability,
} from 'redux/actions/availability';
import { useDateRangeBookabilityQuery } from 'redux/api_slice/availability';

// Get bookability of basic resource and child resources.
// Note: passenger count is always 1.
export const useResourceBookability = ({
  resourceId,
  childResourceIds,
  date,
  passengers,
  passengersCount,
}) => {
  const dispatch = useDispatch();
  const resourceIds = [resourceId, ...childResourceIds];
  const passengerTypeNumbers = passengers;
  const skip = isNil(resourceId) || isNil(date) || !passengersCount;

  const { data, error, isFetching } = useDateRangeBookabilityQuery(
    {
      resourceIds,
      passengerTypeNumbers,
      fromDate: date,
      toDate: date,
    },
    { skip }
  );

  // Update redux store
  useEffect(() => {
    if (!isNil(data)) {
      const temp = { json: data };
      dispatch(setBookability(temp));
    }
  }, [data, dispatch]);

  const params = { travelDate: date, resourceIds, passengerTypeNumbers };

  useEffect(() => {
    if (skip) return;
    if (isFetching) {
      dispatch(fetchBookabilityStarted(params));
    } else if (!isNil(error)) {
      trackError(error);
      dispatch(fetchBookabilityFailure({ ...params, error: error.message }));
    } else if (isNil(error)) {
      dispatch(fetchBookabilitySucceeded(params));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isFetching]);
};
